// extracted by mini-css-extract-plugin
export default {"togglerInput":"TogglerInput_togglerInput__p-7rj","darkMode":"TogglerInput_darkMode__YzwUs"};